import VisitaAngiologicaEdit from "./components/VisitaAngiologicaEdit.vue";
import VisitaAngiologicaView from "./components/VisitaAngiologicaView.vue";
import VisitaAngiologicaList from "./components/VisitaAngiologicaList.vue";

export default {
    VisitaAngiologicaEdit,
    VisitaAngiologicaView,
    VisitaAngiologicaList,
};
